export const BANNER_HOMEPAGE_DELAY_MILLIS = 5000 as const;
export const HEUREKA_REVIEWS_HOMEPAGE_DELAY_MILLIS = 4000 as const;
export const BANNER_LISTING_DELAY_MILLIS = 5000 as const;

export const BANNER_LISTING_PLACEMENT_1_ROW = 3;
export const BANNER_LISTING_PLACEMENT_2_ROW = 7;
